import styled from "styled-components";
import { theme } from "ui";

export const MainContainer = styled.main`
  background-color: ${theme.colors.neutral["25"]};
`;
